import ImagePickerInput from './ImagePickerInput';

export default ImagePickerInput;
